import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'
import { Box } from '@chakra-ui/react'

interface CustomIconProps extends IconProps {
  variant?: string
}

const CheckListAddOutline = createIcon({
  displayName: 'CheckListAddOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M16 11l-5 0" />
        <path d="M16 15l-5 0" />
        <path d="M8.125 10.87l-.01-.001c-.07 0-.13.05-.13.12 0 .06.05.12.12.12 .06-.01.12-.06.12-.13 0 0 0-.001 0-.001v0c0-.07-.06-.125-.125-.125" />
        <path d="M8.125 14.87l-.01-.001c-.07 0-.13.05-.13.12 0 .06.05.12.12.12 .06-.01.12-.06.12-.13 0 0 0-.001 0-.001v0c0-.07-.06-.125-.125-.125" />
        <path d="M3 19l4 0" />
        <path d="M5 21l0-4" />
        <path d="M8 5H6l-.01 0c-1.11 0-2 .89-2 2 0 0 0 0 0 0v7" />
        <rect width="8" height="4" x="8" y="3" rx="1" />
        <path d="M16 5h2l-.01 0c1.1-.01 2 .89 2 1.99v12 0c0 1.1-.9 2-2 2h-8" />
      </g>
      <path fill="none" d="M0 0h24v24H0Z" />
    </>
  ),
})

const CheckListAddTwoTone = createIcon({
  displayName: 'CheckListAddTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" strokeLinecap="round" strokeWidth="1.5" stroke="twoToneLightColor" fill="none" strokeLinejoin="round">
        <Box as="path" d="M16 11l-5 0" />
        <path d="M16 15l-5 0" />
        <path d="M8.125 10.87l-.01-.001c-.07 0-.13.05-.13.12 0 .06.05.12.12.12 .06-.01.12-.06.12-.13 0 0 0-.001 0-.001v0c0-.07-.06-.125-.125-.125" />
        <path d="M8.125 14.87l-.01-.001c-.07 0-.13.05-.13.12 0 .06.05.12.12.12 .06-.01.12-.06.12-.13 0 0 0-.001 0-.001v0c0-.07-.06-.125-.125-.125" />
        <path d="M3 19l4 0" />
        <path d="M5 21l0-4" />
        <path d="M8 5H6l-.01 0c-1.11 0-2 .89-2 2 0 0 0 0 0 0v7" />
        <rect width="8" height="4" x="8" y="3" rx="1" />
        <path d="M16 5h2l-.01 0c1.1-.01 2 .89 2 1.99v12 0c0 1.1-.9 2-2 2h-8" />
      </Box>
      <Box as="path" fill="none" d="M0 0h24v24H0Z" />
    </>
  ),
})

const CheckListAdd: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={CheckListAddTwoTone} {...props} />

  return <CustomIcon as={CheckListAddOutline} {...props} />
}

export default memo(CheckListAdd)
